import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { DirectoryTagsPage } from '../features/directory-tags/pages/DirectoryTagsPage';
import { GaragesPage } from '../features/garages/pages/GaragesPage';
import { ServiceItemsPage } from '../features/service-items/pages/ServiceItemsPage';
import { PartTypesPage } from '../features/part-types/pages/PartTypesPage';
import { PartsPage } from '../features/parts/pages/PartsPage';
import { TyresPage } from '../features/tyres/pages/TyresPage';
import { SuppliersPage } from '../features/suppliers/pages/SuppliersPage';
import { WorkOrdersPage } from '../features/work-orders/pages/WorkOrdersPage';
import { WorkshopBookingsPage } from '../features/workshop-bookings/pages/WorkshopBookingsPage';
import { MAINTENANCE_TAB_LABELS, maintenanceTabPath, type MaintenanceTab } from '../maintenance.paths';

/** The Maintenance nav section's landing page: service items, garages, workshop bookings, suppliers, tyres, parts fitted, part types and their catalogues are all real screens, so `/maintenance` picks between them with tabs. */
export function MaintenancePage({ tab }: { tab: MaintenanceTab }) {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('maintenance')}
        title="Maintenance"
        description="What each truck is serviced for, and who it's sent to for work and parts."
      />
      <Tabs
        activeKey={tab}
        onChange={(key) => navigate(maintenanceTabPath(key as MaintenanceTab))}
        items={[
          { key: 'service-items', label: MAINTENANCE_TAB_LABELS['service-items'], children: <ServiceItemsPage /> },
          { key: 'work-orders', label: MAINTENANCE_TAB_LABELS['work-orders'], children: <WorkOrdersPage /> },
          { key: 'garages', label: MAINTENANCE_TAB_LABELS.garages, children: <GaragesPage /> },
          { key: 'workshop-bookings', label: MAINTENANCE_TAB_LABELS['workshop-bookings'], children: <WorkshopBookingsPage /> },
          { key: 'suppliers', label: MAINTENANCE_TAB_LABELS.suppliers, children: <SuppliersPage /> },
          { key: 'tyres', label: MAINTENANCE_TAB_LABELS.tyres, children: <TyresPage /> },
          { key: 'parts', label: MAINTENANCE_TAB_LABELS.parts, children: <PartsPage /> },
          { key: 'part-types', label: MAINTENANCE_TAB_LABELS['part-types'], children: <PartTypesPage /> },
          { key: 'catalogues', label: MAINTENANCE_TAB_LABELS.catalogues, children: <DirectoryTagsPage /> },
        ]}
      />
    </>
  );
}
